import MaterialNameStack from '#/modules/imsMgmt/receipts/shared/MaterialNameStack';

function formatWarehouseLocation(warehouse) {
  if (!warehouse) {
    return '-';
  }

  const location = warehouse.location;
  const warehouseLabel = warehouse.name || '-';

  if (!location) {
    return warehouseLabel;
  }

  const locationLabel = location.name || '-';

  return `${warehouseLabel} / ${locationLabel}`;
}

function formatInvTransactionSummary(invTransaction) {
  if (!invTransaction) {
    return '-';
  }

  const qtyBefore = invTransaction.qtyBefore;
  const qtyAfter = invTransaction.qtyAfter;
  if (qtyBefore == null && qtyAfter == null) {
    return '-';
  }

  return `${qtyBefore ?? '-'} → ${qtyAfter ?? '-'}`;
}

export function buildStockIssueLineColumns({ showCompletedFields = false } = {}) {
  const columns = [
    {
      id: 'stockNo',
      header: '庫存編號',
      size: 140,
      enableSorting: false,
      cell: ({ row }) => row.original.invStock?.stockNo
        || row.original.invStock?.id
        || '-',
    },
    {
      id: 'mtr',
      header: '物料',
      size: 180,
      enableSorting: false,
      meta: { cellClassName: 'td_left' },
      cell: ({ row }) => {
        const mtr = row.original.mtr;
        if (!mtr) {
          return '-';
        }
        return <MaterialNameStack name={mtr.name} code={mtr.mtrNo} />;
      },
    },
    {
      id: 'warehouse',
      header: '倉／儲位',
      size: 180,
      enableSorting: false,
      meta: { cellClassName: 'td_left' },
      cell: ({ row }) => formatWarehouseLocation(row.original.warehouse),
    },
    {
      id: 'qty',
      header: '數量',
      size: 88,
      enableSorting: false,
      meta: { cellClassName: 'text-right' },
      cell: ({ row }) => {
        const qty = row.original.qty;
        const unit = row.original.unit?.code;
        if (qty == null) {
          return '-';
        }
        return unit ? `${qty} ${unit}` : String(qty);
      },
    },
    {
      id: 'remark',
      header: '備註',
      size: 140,
      enableSorting: false,
      meta: { cellClassName: 'td_left' },
      cell: ({ row }) => row.original.remark || '-',
    },
  ];

  if (showCompletedFields) {
    columns.push({
      id: 'invTransaction',
      header: '異動',
      size: 120,
      enableSorting: false,
      meta: { cellClassName: 'text-right' },
      cell: ({ row }) => formatInvTransactionSummary(row.original.invTransaction),
    });
  }

  return columns;
}
